import { gql } from 'apollo-angular'

export const GET_ORGANIZATION_INVOICE_PRICES = gql`
  query OrganizationInvoicePrices {
    organizationInvoicePrices {
      organizationId
      currentInvoicePrice
      scheduledInvoicePrice
    }
  }
`
